export const SEO_FEATURE_NAME = 'seo';
